export function setSupplies(state, supplies) {
    state.supplies = supplies;
}

export function setSupply(state, supply) {
    state.supply = supply;
}

